import API from '../../../lib/commons/api'
import { ProgressValue } from '../../../domain/value-object/ProjectPlanSnapshot'

/**
 * チケット管理表ごとの進捗。チケット管理表別進捗状況の行になる。
 *
 * 管理表のチケットだけを数え、チケット配下のタスクは数えない。チケットは
 * WBS項目としてはタスクなので、集計値のタスクの欄に入る。
 * 版のスナップショットに無い管理表は行が返らない。
 */
export const pivotByTicketListUuids = async (
  snapshotUuid: string,
  ticketListUuids: string[]
): Promise<ProgressValue[]> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/projects/plans/snapshot/pivot/ticket-lists',
    { snapshotUuid, ticketListUuids }
  )
  // 接続に失敗すると共通 API クライアントは通知を出したうえで空の応答を返す。行なしとして扱う
  if (!Array.isArray(response.json)) return []
  return response.json as ProgressValue[]
}
